/**
 * Search Item - FutureShop
 */

// 色で選ぶ
export function fsSearchItemColor() {
  document.addEventListener('DOMContentLoaded', function() {
    // data-searchの値と対応するチェックボックスのIDのマッピング
    var mappings = {
      // 'data-searchの値': '対応するチェックボックスのID',
      'focus': ['color_blue', 'color_orange'],
      'crimson': ['color_red', 'color_orange'],
      'candy': ['color_pink', 'color_orange'],
      'ohisama': ['color_orange'],
      'midori': ['color_green'],
      'rouge': ['color_pink'],
      'viola': ['color_purple'],
      'kotobuki': ['color_red', 'color_white'],
      'scarlet': ['color_red'],
      'familia': ['color_pink', 'color_blue'],
      'sakura': ['color_pink'],
      'kinari': ['color_white'],
      'indigo': ['color_blue', 'color_white'],
      'fujiiro': ['color_purple'],
      'bran': ['color_white'],
    };

    var searchDataElement = document.querySelector('[data-search]');
    // console.log(searchDataElement);

    // if (searchDataElement !== null) {
    //   // data-search属性の値を取得
    //   var searchData = searchDataElement.getAttribute('data-search');

    //   // searchDataがマッピングに存在する場合、対応するチェックボックスにチェックを入れる
    //   if (mappings[searchData]) {
    //     document.getElementById(mappings[searchData]).checked = true;
    //   }
    // }

    if (searchDataElement !== null) {
      var searchData = searchDataElement.getAttribute('data-search');
      // searchDataがマッピングに存在する場合、対応するチェックボックスID配列を取得し、全てのチェックボックスにチェックを入れる
      var checkBoxIDs = mappings[searchData];
      if (checkBoxIDs) {
        checkBoxIDs.forEach(function(checkBoxID) {
          var checkBox = document.getElementById(checkBoxID);
          if (checkBox) {
            checkBox.checked = true;
          }
        });
      }
    }

  });
}

// 予算で選ぶ
export function fsSearchItemPrice() {
  document.addEventListener('DOMContentLoaded', function() {
    // data-searchの値と対応するセレクトボックスのvalue値のマッピング
    var mappings = {
      // 'data-searchの値': '対応する<option>のvalue値'
      'prc-ss': {
        'minPriceSelect': '',
        'maxPriceSelect': '5000'
      },
      'prc-mc': {
        'minPriceSelect': '',
        'maxPriceSelect': '8000'
      },
      'prc-ms': {
        'minPriceSelect': '',
        'maxPriceSelect': '10000'
      },
      'prc-l': {
        'minPriceSelect': '',
        'maxPriceSelect': '15000'
      },
      'prc-2l': {
        'minPriceSelect': '',
        'maxPriceSelect': '20000'
      },
      'prc-3l': {
        'minPriceSelect': '',
        'maxPriceSelect': '30000'
      },
    };

    var searchDataElement = document.querySelector('[data-search]');

    if (searchDataElement !== null) {
      // data-search属性の値を取得
      var searchData = searchDataElement.getAttribute('data-search');

      // searchDataがマッピングに存在する場合、対応するセレクトボックスの項目を選択状態にする
      if (mappings[searchData]) {
        var mapping = mappings[searchData];
        for (var selectBoxId in mapping) {
          var selectBox = document.getElementById(selectBoxId);
          if (selectBox) {
              selectBox.value = mapping[selectBoxId];
          }
        }
      }
    }
  });
}
